import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3C12.5523 3 13 3.44772 13 4V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V4C11 3.44772 11.4477 3 12 3Z"
        fill="currentColor"
      />
      <path
        d="M12 18C12.5523 18 13 18.4477 13 19V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V19C11 18.4477 11.4477 18 12 18Z"
        fill="currentColor"
      />
      <path
        d="M21 12C21 12.5523 20.5523 13 20 13H19C18.4477 13 18 12.5523 18 12C18 11.4477 18.4477 11 19 11H20C20.5523 11 21 11.4477 21 12Z"
        fill="currentColor"
      />
      <path
        d="M6 12C6 12.5523 5.55228 13 5 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H5C5.55228 11 6 11.4477 6 12Z"
        fill="currentColor"
      />
      <path
        d="M18.364 5.63604C18.7545 6.02656 18.7545 6.65973 18.364 7.05025L17.6569 7.75736C17.2664 8.14788 16.6332 8.14788 16.2427 7.75736C15.8522 7.36683 15.8522 6.73367 16.2427 6.34315L16.9498 5.63604C17.3403 5.24552 17.9735 5.24552 18.364 5.63604Z"
        fill="currentColor"
      />
      <path
        d="M7.75736 16.2426C8.14788 16.6332 8.14788 17.2663 7.75736 17.6569L7.05025 18.364C6.65973 18.7545 6.02656 18.7545 5.63604 18.364C5.24551 17.9734 5.24551 17.3403 5.63604 16.9497L6.34314 16.2426C6.73367 15.8521 7.36683 15.8521 7.75736 16.2426Z"
        fill="currentColor"
      />
      <path
        d="M18.364 18.364C17.9735 18.7545 17.3403 18.7545 16.9498 18.364L16.2427 17.6569C15.8522 17.2663 15.8522 16.6332 16.2427 16.2426C16.6332 15.8521 17.2664 15.8521 17.6569 16.2426L18.364 16.9497C18.7545 17.3403 18.7545 17.9734 18.364 18.364Z"
        fill="currentColor"
      />
      <path
        d="M7.75736 7.75736C7.36683 8.14788 6.73367 8.14788 6.34315 7.75736L5.63604 7.05025C5.24552 6.65973 5.24552 6.02656 5.63604 5.63604C6.02656 5.24551 6.65973 5.24551 7.05025 5.63604L7.75736 6.34314C8.14788 6.73367 8.14788 7.36683 7.75736 7.75736Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgComponent;
